export const check = {
  isApp: () => !!window.ReactNativeWebView,
};
